import { gql, useQuery, useMutation } from '@apollo/client';

export const GET_USER_PREFERENCES = gql`
  query GetUserPreferences {
    userPreferences {
      language
    }
  }
`;

export const UPDATE_USER_PREFERENCES = gql`
  mutation UpdateUserPreferences($preferences: UserPreferencesInput!) {
    updateUserPreferences(preferences: $preferences) {
      language
    }
  }
`;

export default function useUserPreferences() {
  const { data, loading: isLoading, error } = useQuery(GET_USER_PREFERENCES);
  const [updateUserPreferences, { loading: isUpdating }] = useMutation(UPDATE_USER_PREFERENCES);

  return {
    userPreferences: data?.userPreferences || null,
    isLoading,
    error,
    updateUserPreferences,
    isUpdating,
  };
}
